(function () {
document.addEventListener('click', function(e) {
    var btn = e.target.closest('.news-grid__load-more');
    if (!btn) return;
    var grid = btn.closest('.wp-block-buttons').previousElementSibling;
    var offset = parseInt(btn.dataset.offset, 10);
    var perPage = parseInt(btn.dataset.perPage, 10);
    var postType = btn.dataset.postType || 'news';
    btn.disabled = true;
    var body = new URLSearchParams({
        action: newsGridAjax.action,
        offset: offset,
        per_page: perPage,
        post_type: postType
    });
    fetch(newsGridAjax.ajax_url, {
        method: 'POST',
        body: body
    }).then(function(r) {
        return r.json();
    }).then(function(data) {
        if (!data.result) {
            console.error('news-grid load more error:', data.msg);
            btn.disabled = false;
            return;
        }
        grid.insertAdjacentHTML('beforeend', data.html);
        btn.dataset.offset = offset + perPage;
        if (!data.has_more) btn.remove();
        else btn.disabled = false;
    }).catch(function(err) {
        console.error('news-grid AJAX failed:', err);
        btn.disabled = false;
    });
});

})();
//# sourceMappingURL=ajax.js.map
